import AboutComponent from "./components/About/About";
import AttendanceComponent from "./components/Attendance/Attendance";
import Dashboard from "./components/Dashboard/Dashboard";
import Home from "./components/Home/Home";
import Rating from "./components/Rating/Rating";
import UserManagement from "./components/UserManagement/UserManagement";
import DataManagement from "./components/DataManagement/DataManagement";
import ZoomApp from "./components/Zoom/ZoomApp";
import { InsertChartOutlined, Group, HowToReg, StarBorder, Dataset, Analytics, LibraryBooks, VerifiedUserOutlined, Assignment, Work, VideoCall, AssessmentOutlined, Stadium, StadiumOutlined, AppRegistration, LinkedIn, Feedback } from '@mui/icons-material';
import ComingSoon from "./components/ComingSoon";
import AssignmentsIndex from "./components/Assigments/AssignmentsIndex";
import ResourceIndex from "./components/ResourceHub/ResourceIndex";
import AssessmentIndex from "./components/Assessments/AssessmentIndex";
import ActivityIndex from "./components/Activities/Index";
import MicroLearningPage from "./components/MicroLearning/MicroLearningPage";
import LinkedInFeed from "./components/About/LinkedInFeed";
import GrowthSessionManagement from "./components/GrowthSessions/GrowthSessionManagement";

const Routes = {
    mainRoutes: [
        {
            path: "/Home",
            name: "Home",
            component: Home,
            // icon: <AppRegistration />, // Removed to hide from sidebar
        },
        {
            // icon: DashboardLight,
        },
        {
            path: '/Dashboard',
            name: "Dashboard",
            component: Dashboard,
            role: "Mentor,Client, Lead",
            status: "active",
            environment: "DEV, PROD",
            icon: <InsertChartOutlined />,
        },
        {
            path: "/AssessmentIndex",
            name: "Assessments",
            role: "Mentor,User",
            status: "active",
            environment: "DEV, PROD",
            component: AssessmentIndex,
            icon: <AssessmentOutlined />,
        },
        {
            path: "/UserManagement",
            name: "User Management",
            role: "Mentor",
            status: "active",
            environment: "DEV, PROD",
            component: UserManagement,
            icon: <Group />,
        },
        {
            path: "/DataManagement",
            name: "Data Management",
            status: "active",
            role: "Mentor",
            environment: "DEV, PROD",
            component: DataManagement,
            icon: <Dataset />,
        },
        
        {
            path: '/LinkedInFeed',
            name: "LinkedIn Feed",
            status: "inactive-prod",
            role: "Mentor, User",
            environment: "DEV",
            component: LinkedInFeed,
            icon: <LinkedIn />,
        },
        {
            path: "/Attendance",
            name: "Minute Minder",
            status: "inactive-prod",
            role: "Mentor, User",
            component: AttendanceComponent,
            environment: "DEV, PROD",
            icon: <HowToReg />,
        },
         {
            path: "/Rating",
            name: "Self-Reflect & Rise",
            component: Rating,
            role: "Mentor, User",
            status: "active-dev",
            environment: "DEV, PROD",
            icon: <StarBorder />,
        },
         {
            path: "/FeedbackManagement",
            name: "Growth Conversations",
            component: GrowthSessionManagement,
            role: "Manager, Lead, Mentor, User",
            status: "active",
            environment: "DEV, PROD",
            icon: <Feedback />,
        },
        // {
        //     path: "/About",
        //     name: "About",
        //     component: AboutComponent,
        //     // icon: DashboardLight,
        // },
        // {
        //     path: "/Index",
        //     name: "Team Activities",
        //     component: ActivityIndex,
        //     icon: <StadiumOutlined />,
        // },
        // {
        //     path: "/MicroLearningPage",
        //     name: "Micro Learning",
        //     component: MicroLearningPage,
        //     icon: <Dataset />,
        // },
        
        // {
        //     path: "/ZoomApp",
        //     name: "Meeting",
        //     component: ZoomApp,
        //     icon: <VideoCall />,
        // },
        // {
        //     path: "/AssignmentsIndex",
        //     name: "Work Assignments",
        //     component: AssignmentsIndex,
        //     icon: <Assignment />,
        // },

        // {
        //     path: "/ComingSoon",
        //     name: "Growth & Progress",
        //     component: ComingSoon,
        //     icon: <Analytics />,
        // },
        // {
        //     path: "/ResourceIndex",
        //     name: "Resource Hub",
        //     component: ResourceIndex,
        //     icon: <LibraryBooks />,
        // },
        // {
        //     path: "/ComingSoon",
        //     name: "Career Profiles",
        //     component: ComingSoon,
        //     icon: <VerifiedUserOutlined />,
        // },
        // {
        //     path: "/ComingSoon",
        //     name: "Performance Trials",
        //     component: ComingSoon,
        //     icon: <Work />,
        // }
    ]
}

export default Routes;